import { render, staticRenderFns } from "./TableViewV2.vue?vue&type=template&id=5e5787bd&scoped=true"
import script from "./TableViewV2.vue?vue&type=script&lang=js"
export * from "./TableViewV2.vue?vue&type=script&lang=js"
import style0 from "./TableViewV2.vue?vue&type=style&index=0&id=5e5787bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5787bd",
  null
  
)

export default component.exports